export function makeBanner(bannerDetails) {
  let bannerImage = makeBannerImage(bannerDetails.banner_image);
  let banner = new Banner(bannerImage);
  banner.id  = bannerDetails.id;
  banner.campaignName = bannerDetails.campaign_name;
  banner.referralLink = bannerDetails.referral_link;
  banner.trackingHTMLCode = bannerDetails.tracking_html_code;
  banner.referralCode = bannerDetails.member_referral_name.name;
  banner.website = bannerDetails.member_website !== null ? bannerDetails.member_website.website : '';

  return banner;
}

export function makeBannerImage(bannerImageDetails) {
  let bannerImage = new BannerImage();
  bannerImage.dimension = bannerImageDetails.dimension;
  bannerImage.id = bannerImageDetails.id;
  bannerImage.filename = bannerImageDetails.filename;
  bannerImage.language = bannerImageDetails.language_text;
  bannerImage.type = bannerImageDetails.type_title_text;
  
  return bannerImage;
}

export class BannerImage {
  constructor() {
    this._id = null;
    this._dimension = null;
    this._filename = null;
    this._language = null;
    this._type = null;
  }

  set id(id) {
    this._id = id;
  }

  get id() {
    return this._id;
  }

  set dimension(dimension) {
    this._dimension = dimension;
  }

  get dimension() {
    return this._dimension;
  }

  set filename(filename) {
    this._filename = filename;
  }

  get filename() {
    return this._filename;
  }

  set language(language) {
    this._language = language;
  }

  get language() {
    return this._language;
  }

  set type(type) {
    this._type = type;
  }

  get type() {
    return this._type;
  }
}

export class Banner {
  constructor(bannerImage) {
    this._bannerImage = bannerImage;
    this._id = null;
    this._campaignName = null;
    this._referralLink = null;
    this._trackingHTMLCode = null;
  
    this.referralCode = null;
    this.website = null;
  }

  set bannerImage(bannerImage) {
    this._bannerImage = bannerImage;
  }

  get bannerImage() {
    return this._bannerImage;   
  }

  set id(id) {
    this._id = id;
  }

  get id() {
    return this._id;
  }

  set campaignName(campaignName) {
    this._campaignName = campaignName;
  }

  get campaignName() {
    return this._campaignName;
  }

  set referralLink(referralLink) {
    this._referralLink = referralLink;
  }

  get referralLink() {
    return this._referralLink;
  }

  set trackingHTMLCode(trackingHTMLCode) {
    this._trackingHTMLCode = trackingHTMLCode;
  }

  get trackingHTMLCode() {
    return this._trackingHTMLCode;
  }

  set referralCode(referralCode) {
    this._referralCode = referralCode;
  }

  get referralCode() {
    return this._referralCode;
  }

  set website(website) {
    this._website = website;
  }

  get website() {
    return this._website;
  }
}


// WEBPACK FOOTER //
// ./client/app/api/models/banner.model.js